import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/user',
  component: LAYOUT,
  name: 'User',
  redirect: '/user/sign/index',
  meta: {
    title: '个人中心',
  },
  children: [
    {
      path: 'sign/index',
      name: 'userSignIndex',
      meta: {
        title: '每日签到',
      },
      component: () => import('@/views/user/sign/index'),
    },
    {
      path: 'sign/rule',
      name: 'userSignRule',
      meta: {
        title: '签到规则',
      },
      component: () => import('@/views/user/sign/rule'),
    },
    {
      path: 'driveList/index',
      name: 'userSignRule',
      meta: {
        title: '我的试驾',
      },
      component: () => import('@/views/user/driveList/index'),
    },
    {
      path: 'driveList/sign',
      name: 'userSignRule',
      meta: {
        title: '到店签到',
      },
      component: () => import('@/views/user/driveList/sign'),
    },
  ],
};
